import React from 'react';
import Icon from 'components/AppIcon';

const PasswordStrengthIndicator = ({ password, strength }) => {
  const requirements = [
    { label: 'At least 8 characters', met: password?.length >= 8 },
    { label: 'Uppercase letter (A-Z)', met: /[A-Z]/?.test(password) },
    { label: 'Number (0-9)', met: /[0-9]/?.test(password) },
    { label: 'Special character (!@#$...)', met: /[^A-Za-z0-9]/?.test(password) },
  ];

  const filledBars = strength?.score || 0;

  const barColors = [
    'bg-red-500',
    'bg-red-500',
    'bg-orange-500',
    'bg-yellow-500',
    'bg-blue-500',
    'bg-green-500',
  ];

  return (
    <div className="mt-3 space-y-2">
      {/* Strength Bars */}
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5]?.map((bar) => (
          <div
            key={bar}
            className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${
              bar <= filledBars ? barColors?.[filledBars] : 'bg-border'
            }`}
          />
        ))}
      </div>
      {/* Strength Label */}
      {strength?.label && (
        <p className={`text-xs font-medium ${
          filledBars <= 2 ? 'text-red-500' :
          filledBars === 3 ? 'text-yellow-600' :
          filledBars === 4 ? 'text-blue-600' : 'text-green-600'
        }`}>
          Password strength: {strength?.label}
        </p>
      )}
      {/* Requirements */}
      <div className="grid grid-cols-2 gap-1">
        {requirements?.map((req, idx) => (
          <div key={idx} className="flex items-center gap-1.5">
            <div className={`w-3.5 h-3.5 rounded-full flex items-center justify-center flex-shrink-0 ${
              req?.met ? 'bg-green-100' : 'bg-border'
            }`}>
              {req?.met ? (
                <Icon name="Check" size={9} className="text-green-600" />
              ) : (
                <Icon name="Minus" size={9} className="text-text-secondary" />
              )}
            </div>
            <span className={`text-xs ${
              req?.met ? 'text-green-600' : 'text-text-secondary'
            }`}>
              {req?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;